import React, { useState, useCallback } from 'react';
import {
  Create,
  SimpleForm,
  ImageInput,
  TextInput,
  SelectInput,
  BooleanInput,
  FormDataConsumer,
  ImageField,
  Toolbar,
  SaveButton,
  required,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { equipmentSelectableOptions } from '../../../constants/equipment';
import { difficultySelectableOptions } from '../../../constants/difficulty';
import uploadPicture from '../../../utils/uploadPicture';
import Loading from '../../../components/Loading/Loading';
import ImagePickerButton from '../../../components/ImagePickerButton/ImagePickerButton';
import dataProvider from '../../../providers/dataProvider';

const ProgramCreateToolbar = ({ loading, ...props }) => {
  return (
    <>
      <Loading open={loading} />
      <Toolbar {...props}>
        <SaveButton />
      </Toolbar>
    </>
  );
};

const CreateProgram = (props) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    async (values) => {
      setLoading(true);
      try {
        const res = await uploadPicture(values.picture);
        const newValues = { ...values };
        if (values.isExternal) {
          newValues.complexity = 0;
          newValues.equipment = 0;
        } else {
          delete newValues.externalLink;
          delete newValues.isAlphaPosse;
        }
        await dataProvider.create('programs', {
          data: { ...newValues, picture: res.data.fileName },
        });
        navigate('/programs');
      } finally {
        setLoading(false);
      }
    },
    [navigate],
  );

  return (
    <Create {...props}>
      <SimpleForm onSubmit={handleSubmit} toolbar={<ProgramCreateToolbar loading={loading} />}>
        <TextInput source="name" label="Program Name" validate={required()} />
        <BooleanInput source="isExternal" label="Is External" />
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (formData.isExternal) {
              return (
                <>
                  <BooleanInput
                    source="isAlphaPosse"
                    label="Is Alpha Posse, (allow add/remove access to discourse for this program)"
                    {...rest}
                  />
                  <br />
                  <TextInput
                    source="externalLink"
                    label="External Link"
                    validate={required()}
                    {...rest}
                  />
                </>
              );
            }

            return (
              <>
                <SelectInput
                  label="Equipment"
                  source="equipment"
                  choices={equipmentSelectableOptions}
                  validate={required()}
                  {...rest}
                />
                <br />
                <SelectInput
                  label="Type"
                  source="complexity"
                  choices={difficultySelectableOptions}
                  validate={required()}
                  {...rest}
                />
              </>
            );
          }}
        </FormDataConsumer>
        <TextInput source="description" label="Description" validate={required()} />
        <ImageInput
          source="picture"
          label="Add Program Photo"
          accept={{ 'image/*': [] }}
          validate={required()}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
        <ImagePickerButton source="picture" label={false} />
      </SimpleForm>
    </Create>
  );
};

export default CreateProgram;
